module.exports = __webpack_public_path__ + "img/inter26.2942cf24.jpg";